import axios from 'axios';

export class AttachmentService {
  static async upload(
    documentId: string,
    recipientId: string,
    authId: string,
    attachmentId: string,
    file: File
  ): Promise<void> {
    const body = new FormData();
    body.append('file', file);
    await axios.post(
      `/view/${documentId}/${recipientId}/${authId}/upload/attachment/${attachmentId}`,
      body
    );
  }
}
